export const pos = {
  // Titres et en-têtes
  title: 'Point de Vente',
  subtitle: 'Terminal de caisse',
  
  // Panier (Cart)
  cart: {
    title: 'Panier',
    empty: 'Panier vide',
    emptyMessage: 'Ajoutez des produits pour commencer',
    items: 'article',
    itemsPlural: 'articles',
    total: 'Total',
    pay: 'Payer',
    clear: 'Vider le panier',
    clearConfirm: 'Êtes-vous sûr de vouloir vider le panier ?',
    removeItem: 'Supprimer',
    quantity: 'Quantité',
    unitPrice: 'Prix unitaire',
    lineTotal: 'Total ligne'
  },

  // Modal de paiement (CheckoutModal)
  checkout: {
    title: 'Finaliser le Paiement',
    receiptTitle: 'Ticket de Caisse',
    
    // Récapitulatif de commande
    orderSummary: {
      title: 'Récapitulatif de la commande',
      subtotal: 'Sous-total',
      tva: 'TVA',
      totalToPay: 'Total à payer'
    },

    // Informations client
    customer: {
      name: 'Nom du client',
      namePlaceholder: 'Nom du client',
      phone: 'Téléphone',
      phonePlaceholder: 'Numéro de téléphone',
      notes: 'Notes',
      notesPlaceholder: 'Notes additionnelles...'
    },

    // Méthodes de paiement
    paymentMethods: {
      title: 'Méthode de paiement',
      cash: 'Espèces',
      card: 'Carte bancaire',
      check: 'Chèque',
      transfer: 'Virement',
      mobile: 'Mobile Money'
    },

    // Montant reçu
    amountReceived: {
      title: 'Montant reçu',
      placeholder: '0.00',
      quickAmounts: 'Montants rapides',
      insufficient: 'Montant insuffisant',
      change: 'Monnaie à rendre'
    },

    // Boutons d'action
    actions: {
      cancel: 'Annuler',
      finalize: 'Finaliser',
      finalizeCredit: 'Finaliser en Crédit',
      processing: 'Traitement...',
      close: 'Fermer',
      print: 'Imprimer'
    },

    // Messages d'erreur
    errors: {
      insufficientAmount: 'Le montant reçu doit être supérieur ou égal au montant total',
      insufficientAmountConfirm: 'Le montant reçu est insuffisant. Voulez-vous finaliser la vente en crédit ?',
      paymentError: 'Erreur lors du paiement. Veuillez réessayer.',
      emptyCart: 'Le panier est vide. Ajoutez des produits avant de procéder au paiement.'
    }
  },

  // Ticket de caisse (Receipt)
  receipt: {
    title: 'TICKET DE CAISSE',
    saleNumber: 'Vente #',
    client: 'Client',
    articles: 'Articles',
    payment: 'Paiement',
    method: 'Méthode',
    amountReceived: 'Montant reçu',
    change: 'Monnaie',
    notes: 'Notes',
    thankYou: 'Merci pour votre achat !',
    keepTicket: 'Conservez ce ticket',
    subtotal: 'Sous-total',
    total: 'Total'
  },

  // Barre de statut (StatusBar)
  statusBar: {
    currentSale: 'Vente en cours',
    totalItems: 'Total articles',
    totalAmount: 'Montant total',
    ready: 'Prêt',
    processing: 'En cours...',
    offline: 'Hors ligne',
    online: 'En ligne'
  },

  // Grille de produits (ProductGrid)
  productGrid: {
    title: 'Produits',
    search: 'Rechercher un produit...',
    noProducts: 'Aucun produit trouvé',
    noProductsWithCriteria: 'Aucun produit trouvé avec ces critères',
    noProductsAvailable: 'Aucun produit disponible',
    addToCart: 'Ajouter au panier',
    outOfStock: 'Rupture de stock',
    lowStock: 'Stock faible',
    loading: 'Chargement des produits...',
    error: 'Erreur lors du chargement des produits',
    retry: 'Réessayer',
    stock: 'Stock',
    noBarcode: 'Sans code',
    orders: 'Commandes',
    newOrder: 'Nouvelle commande',
    order: 'Commande',
    articles: 'articles',
    categories: {
      all: 'Tous',
      navigation: 'Navigation des catégories'
    },
    // Commentaires et éléments d'interface
    header: 'En-tête avec recherche',
    productGrid: 'Grille de produits',
    categoryFilters: 'Filtres par catégorie avec navigation',
    leftArrow: 'Flèche gauche',
    rightArrow: 'Flèche droite',
    categoryContainer: 'Container des catégories avec scroll'
  },

  // Pavé virtuel (VirtualKeypad)
  virtualKeypad: {
    title: 'Pavé numérique',
    clearCart: 'Vider Panier',
    clearCartConfirm: 'Êtes-vous sûr de vouloir vider le panier ?',
    selectors: {
      quantity: 'Qté',
      discount: 'Remise',
      price: 'Prix'
    },
    buttons: {
      toggleSign: '+/-',
      backspace: '⌫',
      decimal: '.',
      enter: 'Entrée'
    },
    actions: {
      clear: 'Effacer',
      backspace: 'Retour arrière',
      toggleSign: 'Changer de signe'
    }
  },

  // Layouts spécifiques
  layouts: {
    retail: {
      title: 'Commerce de détail',
      products: 'Produits',
      categories: 'Catégories'
    },
    restaurant: {
      title: 'Restaurant',
      menu: 'Menu',
      tables: 'Tables',
      orders: 'Commandes en cours',
      table: 'Table',
      status: {
        active: 'Active',
        empty: 'Libre',
        reserved: 'Réservée'
      },
      orderStatus: {
        preparing: 'En préparation',
        ready: 'Prêt'
      }
    },
    services: {
      title: 'Services',
      services: 'Services',
      clients: 'Clients',
      appointments: 'Rendez-vous',
      timer: 'Chronomètre',
      startTimer: 'Démarrer',
      stopTimer: 'Arrêter',
      resetTimer: 'Reset',
      serviceTime: 'Temps de service',
      newClient: 'Nouveau client',
      searchClient: 'Rechercher un client...',
      lastVisit: 'Dernière visite',
      confirmed: 'Confirmé',
      pending: 'En attente'
    },
    workshop: {
      title: 'Atelier',
      quoteLines: 'Lignes de devis',
      addLine: 'Ajouter ligne',
      description: 'Description',
      quantity: 'Quantité',
      unitPrice: 'Prix unitaire',
      total: 'Total',
      clients: 'Clients',
      newClient: 'Nouveau client',
      searchClient: 'Rechercher un client...',
      quotePreview: 'Aperçu devis',
      quoteNumber: 'Devis #',
      date: 'Date',
      client: 'Client'
    }
  },

  // Notifications
  notifications: {
    paymentSuccess: 'Paiement réussi !',
    saleSaved: 'Vente sauvegardée avec succès',
    error: 'Erreur',
    success: 'Succès',
    warning: 'Attention',
    info: 'Information'
  },

  // Messages généraux
  messages: {
    loading: 'Chargement...',
    saving: 'Sauvegarde...',
    error: 'Une erreur est survenue',
    success: 'Opération réussie',
    confirm: 'Êtes-vous sûr ?',
    cancel: 'Annuler',
    ok: 'OK',
    yes: 'Oui',
    no: 'Non'
  },

  // Formats de date et monnaie
  formats: {
    currency: '€',
    date: 'DD/MM/YYYY',
    time: 'HH:mm',
    datetime: 'DD/MM/YYYY HH:mm'
  }
}; 